import  {__extends} from './eXcell';
import {dhx4} from '../../global/dhx4OrDhx';
import eXcell_ch from './eXcell_ch';
import eXcell_combo from './eXcell_combo';

var eXcell_ra_str = (function (_super) {
    __extends(eXcell_ra_str, _super);
    function eXcell_ra_str(a) {
        _super.call(this, a);
        this.grid = a.parentNode.grid;
    }
    eXcell_ra_str.prototype.setValue = function (e) {
        this.cell.style.verticalAlign = "middle";
        if (e) {
            e = e.toString()._dhx_trim();
            if (e == "false" || e == "0") {
                e = "";
            }
        }
        if (e) {
            if (this.grid.rowsAr[this.cell.parentNode.idd]) {
                for (var c = 0; c < this.grid._cCount; c++) {
                    if (c !== this.cell._cellIndex) {
                        var a = this.grid.cells(this.cell.parentNode.idd, c);
                        if ((a.cell._cellType || this.grid.cellType[a.cell._cellIndex]) !=
                            "ra_str") {
                            continue;
                        }
                        if (a.getValue()) {
                            a.setValue("0");
                        }
                    }
                }
            }
            e = "1";
            this.cell.chstate = "1";
        }
        else {
            e = "0";
            this.cell.chstate = "0";
        }
        this.setCValue("<img src='" +
            this.grid.imgURL +
            "radio_chk" +
            e +
            ".gif' onclick='new eXcell_ra_str(this.parentNode).changeState()'>", this.cell.chstate);
    };
    return eXcell_ra_str;
})(eXcell_ch);
dhx4.attachEvent("onGridCreated", function (c) {
    if (!window.dhx_globalImgPath) {
        window.dhx_globalImgPath = c.imgURL;
    }
    c._col_combos = [];
    for (var a = 0; a < c._cCount; a++) {
        if (c.cellType[a].indexOf("combo") == 0) {
            c._col_combos[a] = eXcell_combo.prototype.initCombo.call({ grid: c }, a);
        }
    }
    if (!c._loading_handler_set) {
        c._loading_handler_set = c.attachEvent("onXLE", function (g, e, m, h, l) {
            if (l != "xml") {
                return;
            }

            eXcell_combo.prototype.fillColumnCombos(this, h);

            this.detachEvent(this._loading_handler_set);

            this._loading_handler_set = null;
        });
    }
});
window.eXcell_ra_str=eXcell_ra_str;
export default eXcell_ra_str;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_ra_str.js